import { render, staticRenderFns } from "./Contact_wrap.vue?vue&type=template&id=c06488ce&scoped=true"
import script from "./Contact_wrap.vue?vue&type=script&lang=js"
export * from "./Contact_wrap.vue?vue&type=script&lang=js"
import style0 from "./Contact_wrap.vue?vue&type=style&index=0&id=c06488ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c06488ce",
  null
  
)

export default component.exports